import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyle } from "./style";

interface IParams {
    price: number;
    priceColor?: string;
    priceFontSize?: string;
    descriptionFontSize?: string;
    direction?: "row" | "column";
}

export const OfferPrice = (props: IParams) => {
    const { price, priceColor, priceFontSize, descriptionFontSize, direction = "column" } = props;
    const { t } = useTranslation("common");
    const { classes } = useStyle({ priceColor, priceFontSize, descriptionFontSize, direction });

    return (
        <div className={classes.container}>
            <Typography className={classes.price}>{t("price", { price })}</Typography>
            <Typography className={classes.description} color="secondary">
                {t("aMonthForLife")}
            </Typography>
        </div>
    );
};
